
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import SocialsHero from './components/SocialsHero';
import SocialsPlatforms from './components/SocialsPlatforms';
import InstagramFeed from './components/InstagramFeed';
import TikTokFeed from './components/TikTokFeed';
import SocialsCTA from './components/SocialsCTA';
import { useSEO, generateWebPageSchema, generateBreadcrumbSchema } from '../../utils/seo';

export default function SocialsPage() {
  const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: 'Follow Brushour on Social Media | Painters Watford Instagram TikTok',
    description: 'Follow Brushour painters and decorators on Instagram, TikTok, Facebook, and YouTube. See our latest painting projects in Watford and Hertfordshire, tips, and special offers.',
    keywords: 'Brushour Instagram, painters TikTok Watford, decorators social media Hertfordshire, painting YouTube Watford, Brushour social media',
    canonical: `${SITE_URL}/socials`,
    schema: [
      generateWebPageSchema('Brushour Social Media – Painters & Decorators Watford', 'Follow Brushour on Instagram, TikTok, Facebook and YouTube for painting and decorating inspiration', `${SITE_URL}/socials`),
      generateBreadcrumbSchema([
        { name: 'Home', url: SITE_URL },
        { name: 'Socials', url: `${SITE_URL}/socials` },
      ]),
    ],
  });

  return (
    <>
      <Navigation />
      <main>
        <SocialsHero />
        <SocialsPlatforms />
        <InstagramFeed />
        <TikTokFeed />
        <SocialsCTA />
      </main>
      <Footer />
    </>
  );
}
